import { atom } from 'recoil';

export const searchCmpBox = atom<string>({
  key: 'searchCmpBox',
  default: '제목'
});
